import { FC, useState } from 'react'

import {
  TableHeadStyled,
  TableCellStyled,
  TableContainerStyled,
  TableRowStyled,
  TableStyled,
  TableBodyStyled,
  TableFooter
} from 'components'
import { EditIcon, WatchCancelIcon, WatchCheckIcon } from 'components/Icons'
import { useLoading, useModal } from 'hooks'
import { JobsService, GetAllJobsResponse } from 'services/NGT/Parameterization'
import { SPACING } from 'utils'

interface ITableJobsProps {
  tableData: GetAllJobsResponse[]
  setJob: React.Dispatch<React.SetStateAction<GetAllJobsResponse>>
  toggleRefreshScreen: () => void
  toggleModalEditJobs: () => void
}

const TableJobs: FC<ITableJobsProps> = ({
  tableData,
  setJob,
  toggleModalEditJobs,
  toggleRefreshScreen
}) => {
  const { showModal } = useModal()
  const { setLoading } = useLoading()

  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(15)

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleDeleteJob = (idHangfireJob: string, nmJob: string) => {
    showModal({
      handleConfirm: () => handleChangeStateDeleteJob(idHangfireJob),
      message: `Excluir JOB ${nmJob}?`,
      txtButtonCancel: 'NÃO',
      txtButtonConfirm: 'SIM',
      type: 'alert'
    })
  }

  const handleChangeStateDeleteJob = (idHangfireJob: string) => {
    setLoading('loading')
    JobsService()
      .deleteJob(idHangfireJob)
      .then((response) => {
        if (response.status === 200) {
          showModal({
            hideButtonCancel: true,
            message: 'Job deletado com sucesso!',
            txtButtonConfirm: 'OK',
            type: 'success'
          })

          toggleRefreshScreen()
        }
      })
      .catch((response) => {
        showModal({
          hideButtonCancel: true,
          message:
            response.detail || 'Não foi possível deletar Job, tente novamente!',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
    setLoading('idle')
  }

  const handleStopJobPlanning = (idHangfireJob: string, nmJob: string) => {
    showModal({
      handleConfirm: () => handleChangeStateJob(idHangfireJob, false),
      message: `Deseja parar o planejamento do JOB ${nmJob}?`,
      txtButtonCancel: 'NÃO',
      txtButtonConfirm: 'SIM',
      type: 'alert'
    })
  }

  const handleStartJobPlanning = (idHangfireJob: string, nmJob: string) => {
    showModal({
      handleConfirm: () => handleChangeStateJob(idHangfireJob, true),
      message: `Deseja ativar o planejamento do JOB ${nmJob}?`,
      txtButtonCancel: 'NÃO',
      txtButtonConfirm: 'SIM',
      type: 'alert'
    })
  }

  const handleChangeStateJob = (idHangfireJob: string, flAtivo: boolean) => {
    setLoading('loading')
    const sucessMessage = flAtivo ? 'Job ativado!' : 'Job desativado!'

    JobsService()
      .suspender(idHangfireJob, flAtivo)
      .then((response) => {
        if (response.status === 200) {
          showModal({
            hideButtonCancel: true,
            message: sucessMessage,
            txtButtonConfirm: 'OK',
            type: 'success'
          })

          toggleRefreshScreen()
        }
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível alterar Status do Job, tente novamente!',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
    setLoading('idle')
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left">Jobs</TableCellStyled>
              <TableCellStyled padding="checkbox" align="left">
                Tipo
              </TableCellStyled>
              <TableCellStyled align="left">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {(rowsPerPage > 0
              ? tableData?.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : tableData
            )?.map((row) => (
              <TableRowStyled key={row?.idJob}>
                <TableCellStyled align="left">{row?.nmJob}</TableCellStyled>
                <TableCellStyled align="left">
                  {row?.jobInfo?.txTipoRecorrencia}
                </TableCellStyled>
                <TableCellStyled
                  align="center"
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  <EditIcon
                    onClick={() => {
                      setJob(row)
                      toggleModalEditJobs()
                    }}
                    cursor="pointer"
                  />
                  {row.flAtivo ? (
                    <WatchCheckIcon
                      onClick={() =>
                        handleStopJobPlanning(row?.idHangfireJob, row?.nmJob)
                      }
                      cursor="pointer"
                    />
                  ) : (
                    <WatchCancelIcon
                      onClick={() =>
                        handleStartJobPlanning(row?.idHangfireJob, row?.nmJob)
                      }
                      marginRight={SPACING.spacing5}
                      marginLeft={SPACING.spacing5}
                      cursor="pointer"
                    />
                  )}
                  {/* <DeleteIcon
                    cursor="pointer"
                    onClick={() =>
                      handleDeleteJob(row?.idHangfireJob, row?.nmJob)
                    }
                  /> */}
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        typeFooter="offline"
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}

export default TableJobs
